var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-grid uk-flex-row uk-flex-top uk-grid-collapse",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-3-4"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-wrap uk-grid-small"
  }, [_c('TenantCombobox', {
    attrs: {
      "label": _vm.$t('fields.tenant')
    },
    model: {
      value: (_vm.filter.tenant),
      callback: function($$v) {
        _vm.filter.tenant = $$v
      },
      expression: "filter.tenant"
    }
  }), _vm._v(" "), _c('div', [_c('form-group', {
    staticClass: "combobox",
    attrs: {
      "label": _vm.$t('labels.filtersInRevisions')
    }
  }, [_c('multiselect', {
    staticClass: "filters-in-revision-combobox",
    attrs: {
      "options": _vm.revisionFiltersOptions,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "Pick some",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.filtersInRevision),
      callback: function($$v) {
        _vm.filtersInRevision = $$v
      },
      expression: "filtersInRevision"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('label', [_vm._v(_vm._s(this.$t('labels.alwaysDisplayed')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.hasAlwaysDisplayed),
      expression: "filter.hasAlwaysDisplayed"
    }],
    ref: "primaryInput",
    staticClass: "uk-select",
    on: {
      "click": _vm.onInput,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter.hasAlwaysDisplayed = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")])])]), _vm._v(" "), _c('ProviderComboBox', {
    model: {
      value: (_vm.filter.provider),
      callback: function($$v) {
        _vm.filter.provider = $$v
      },
      expression: "filter.provider"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('checkbox', {
    staticClass: "product-filter-checkbox",
    attrs: {
      "label": _vm.$t('labels.revisionCheckbox')
    },
    model: {
      value: (_vm.filter.hasRevisions),
      callback: function($$v) {
        _vm.filter.hasRevisions = $$v
      },
      expression: "filter.hasRevisions"
    }
  }), _vm._v(" "), _c('checkbox', {
    staticClass: "product-filter-checkbox",
    attrs: {
      "label": _vm.$t('labels.bundleCheckbox')
    },
    model: {
      value: (_vm.filter.bundle),
      callback: function($$v) {
        _vm.filter.bundle = $$v
      },
      expression: "filter.bundle"
    }
  }), _vm._v(" "), _c('checkbox', {
    staticClass: "product-filter-checkbox",
    attrs: {
      "label": _vm.$t('labels.filterStockSkipUpdateCheckbox')
    },
    model: {
      value: (_vm.filter.hasStockSkipUpdate),
      callback: function($$v) {
        _vm.filter.hasStockSkipUpdate = $$v
      },
      expression: "filter.hasStockSkipUpdate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-top",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-default",
    on: {
      "click": _vm.handleFilterClick
    }
  }, [_vm._v("Filtern")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8dc500","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Products/IndexView/ProductsFilter.vue
// module id = 2046
// module chunks = 0